import Phaser from 'phaser';
import $ from 'jquery';
import { CST } from '../CST';

var clickSound;

export default class CategorySelection extends Phaser.Scene {
	selection = [];
	categorySelected = null;
	oldSelection = null;
	categoryRows = [];
	searchTerm = '';
	selectedAreas = new Set();
	selectedSkills = new Set();
	selectedThemes = new Set();
	categories = [];
	listStartY = 0;
	introActive = true;

	constructor() {
		super(CST.SCENES.CATEGORYSELECTION);
	}

	init() {
		this.selection = [];
		this.categorySelected = null;
		this.oldSelection = null;
		this.categoryRows = [];
		this.searchTerm = '';
		this.selectedAreas = new Set();
		this.selectedSkills = new Set();
		this.selectedThemes = new Set();
		this.categories = [];
		this.listStartY = 0;
		this.introActive = true;
	}

	preload() {
		this.load.image('bg-select-q', 'assets/bg-select-q.png');
		this.load.image('box-scenario', 'assets/preview-scenario.png');
		this.load.image('box-feedback', 'assets/preview-feedback.png');
		this.load.image('tab-scenario', 'assets/preview-scenario-tab.png');
		this.load.image('tab-feedback', 'assets/preview-feedback-tab.png');
		this.load.image('tick', 'assets/tick.png');
		this.load.image('confirm', 'assets/confirm.png');
		this.load.image('select-scenario', 'assets/select-scenario.png');
		this.load.image('unselect-scenario', 'assets/unselect-scenario.png');
		this.load.image('popup-select-scenario', 'assets/popup-select-scenario.png');
		this.load.image('clear', 'assets/clear-btn.png');
		this.load.image('close_btn', 'assets/english/close.png');
		this.load.image('popup-intro', 'assets/popup-intro.png');
		this.load.image('btn-next', 'assets/btn-next.png');
		this.load.image('popup-confirm-selection', 'assets/popup-confirm-selection.png');
		this.load.spritesheet({ key: 'select-all-sprite', url: 'assets/english/select-all-btn.png', frameConfig: { frameWidth: 239.5, frameHeight: 50 } });
		for (let i = 1; i <= 28; i++) {
			this.load.image('preview-scenario-' + i, 'assets/english/preview/scenario-setup (' + i + ').png');
			this.load.image('preview-feedback-' + i, 'assets/english/preview/feedback-setup (' + i + ').png');
		}
	}

	create(data) {
		clickSound = this.sound.add('clickSound');

		const cx = this.cameras.main.width / 2;
		const cy = this.cameras.main.height / 2;

		this.add.image(cx, cy, 'bg-select-q');

		this.scenarioBox = this.add.image(cx + 240, cy - 10, 'box-scenario');
		this.feedbackBox = this.add.image(cx + 240, cy - 10, 'box-feedback').setVisible(false);

		this.scenarioTab = this.add
			.image(cx - 145, cy - 410, 'tab-scenario')
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				clickSound.play();
				this.scenarioBox.setVisible(true);
				this.feedbackBox.setVisible(false);
			});

		this.feedbackTab = this.add
			.image(cx + 47, cy - 410, 'tab-feedback')
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				clickSound.play();
				this.scenarioBox.setVisible(false);
				this.feedbackBox.setVisible(true);
			});

		this.btnCategorySelection = this.add
			.image(cx + 520, cy + 320, '')
			.setInteractive({ useHandCursor: true })
			.setVisible(false)
			.on('pointerdown', () => {
				clickSound.play();
				this.categoryAddition(this.categorySelected);
			});

		this.btnSelectAll = this.add
			.image(cx - 570, cy + 390, 'select-all-sprite')
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => { clickSound.play(); this.selectAll(); });

		this.btnCategoryClear = this.add
			.image(cx - 360, cy + 390, 'clear')
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => { clickSound.play(); this.categoryClear(); });

		this.btnNext = this.add
			.image(cx + 640, cy + 410, 'confirm')
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				clickSound.play();
				if (this.selection.length !== 0) {
					this.showConfirmPopup(data);
				} else {
					this.warning();
				}
			});

		this.showIntroPopup(cx, cy);
		this.loadCategories(cx, cy);
	}

	showIntroPopup(cx, cy) {
		[
			this.scenarioTab,
			this.feedbackTab,
			this.btnCategorySelection,
			this.btnSelectAll,
			this.btnCategoryClear,
			this.btnNext,
		].forEach(btn => btn.disableInteractive());

		this.introOverlay = this.add.rectangle(cx, cy, 1500, 929, 0x000000, 0.6).setDepth(9);
		this.introPopupImg = this.add.image(cx, cy, 'popup-intro').setDepth(10);
		this.introBtnNext = this.add
			.image(cx, cy + 200, 'btn-next')
			.setInteractive({ useHandCursor: true })
			.setDepth(11)
			.on('pointerdown', () => {
				clickSound.play();
				this.introActive = false;
				this.introOverlay.destroy();
				this.introPopupImg.destroy();
				this.introBtnNext.destroy();

				if (this.rootDom) this.rootDom.node.style.filter = '';
				if (this._listEl) {
					this._listEl.style.overflowY = 'auto';
					this._listEl.style.visibility = 'visible';
				}

				[
					this.scenarioTab,
					this.feedbackTab,
					this.btnCategorySelection,
					this.btnSelectAll,
					this.btnCategoryClear,
					this.btnNext,
				].forEach(btn => btn.setInteractive({ useHandCursor: true }));

				if (this.searchDom) this.searchDom.node.disabled = false;
				if (this.dropdownDoms) this.dropdownDoms.forEach(d => (d.node.style.pointerEvents = ''));
				this.categoryRows.forEach(row => row.button.setInteractive({ useHandCursor: true }));
			});
	}

	showConfirmPopup(data) {
		const cx = this.cameras.main.width / 2;
		const cy = this.cameras.main.height / 2;

		[
			this.scenarioTab,
			this.feedbackTab,
			this.btnCategorySelection,
			this.btnSelectAll,
			this.btnCategoryClear,
			this.btnNext,
		].forEach(btn => btn.disableInteractive());
		this.categoryRows.forEach(row => row.button.disableInteractive());

		if (this.rootDom) this.rootDom.node.style.filter = 'brightness(0.4)';
		if (this._listEl) {
			this._listEl.style.overflowY = 'hidden';
			this._listEl.style.visibility = 'hidden';
		}
		if (this.searchDom) this.searchDom.node.disabled = true;
		if (this.dropdownDoms) this.dropdownDoms.forEach(d => (d.node.style.pointerEvents = 'none'));

		const overlay = this.add.rectangle(cx, cy, 1500, 929, 0x000000, 0.6).setDepth(9);
		const popup = this.add.image(cx, cy, 'popup-confirm-selection').setDepth(10);

		const dismiss = () => {
			overlay.destroy();
			popup.destroy();
			btnClose.destroy();
			btnConfirm.destroy();

			[
				this.scenarioTab,
				this.feedbackTab,
				this.btnCategorySelection,
				this.btnSelectAll,
				this.btnCategoryClear,
				this.btnNext,
			].forEach(btn => btn.setInteractive({ useHandCursor: true }));
			this.categoryRows.forEach(row => row.button.setInteractive({ useHandCursor: true }));

			if (this.rootDom) this.rootDom.node.style.filter = '';
			if (this._listEl) {
				this._listEl.style.overflowY = 'auto';
				this._listEl.style.visibility = 'visible';
			}
			if (this.searchDom) this.searchDom.node.disabled = false;
			if (this.dropdownDoms) this.dropdownDoms.forEach(d => (d.node.style.pointerEvents = ''));
		};

		const btnClose = this.add
			.image(cx - 120, cy + 185, 'close_btn')
			.setInteractive({ useHandCursor: true })
			.setDepth(11)
			.on('pointerdown', () => { clickSound.play(); dismiss(); });

		const btnConfirm = this.add
			.image(cx + 120, cy + 185, 'confirm')
			.setInteractive({ useHandCursor: true })
			.setDepth(11)
			.on('pointerdown', () => {
				clickSound.play();
				this.scene.start(CST.SCENES.BOARD, {
					scene: CST.SCENES.MENU,
					language: data.language,
					categories: this.selection,
				});
			});
	}

	loadCategories(cx, cy) {
		$.ajax({
			url: 'website/get-categories.php',
			type: 'GET',
			dataType: 'JSON',
			success: categories => {
				this.categories = categories;
				this.buildFilterUI(cx, cy);
				this.buildCategoryList();
			},
			error: err => {
				console.error('Failed to load categories', err);
			},
		});
	}

	buildFilterUI(cx, cy) {
		this.listStartY = cy - 330;

		const areas = new Set();
		const skills = new Set();
		const themes = new Set();
		this.categories.forEach(cat => {
			if (cat.area) cat.area.split(';').forEach(v => areas.add(v.trim()));
			if (cat.skills) cat.skills.split(';').forEach(v => skills.add(v.trim()));
			if (cat.themes) cat.themes.split(';').forEach(v => themes.add(v.trim()));
		});

		// Single root DOM — search + dropdowns + list share one stacking context,
		// which is what makes dropdown panels render above the list (z-index works).
		this.rootDom = this.add.dom(cx - 695, cy - 422).createElement('div');
		this.rootDom.node.style.cssText =
			'position:relative;width:415px;height:750px;overflow:visible;';
		const rootWrapper = this.rootDom.node.parentElement;
		if (rootWrapper) rootWrapper.style.overflow = 'visible';

		// --- Search ---
		const searchInput = document.createElement('input');
		searchInput.type = 'text';
		searchInput.placeholder = 'Search (comma-separated)';
		searchInput.className = 'input_text_2';
		Object.assign(searchInput.style, {
			display: 'block',
			width: '415px',
			height: '46px',
			padding: '12px 14px',
			marginBottom: '6px',
			fontSize: '17px',
			borderRadius: '2em',
			border: '2px solid #ccc',
			background: 'rgba(255,255,255,0.95)',
			color: '#000000',
			boxSizing: 'border-box',
		});
		searchInput.addEventListener('input', e => {
			this.searchTerm = e.target.value;
			this.filterCategories();
		});
		searchInput.addEventListener('keydown', e => e.stopPropagation());
		this.rootDom.node.appendChild(searchInput);
		this.searchDom = { node: searchInput };

		// --- Dropdown bar (flex, 3 equal-width buttons) ---
		this._ddPanels = [];
		const ddBar = document.createElement('div');
		ddBar.style.cssText = 'display:flex;gap:8px;margin-bottom:6px;';

		const makeDropdown = (label, options, getCount, onToggle) => {
			const wrap = document.createElement('div');
			wrap.style.cssText = 'position:relative;flex:1;';

			const btn = document.createElement('button');
			const updateLabel = () => {
				const n = getCount();
				btn.textContent = n > 0 ? `${label} (${n}) ▼` : `${label} ▼`;
			};
			updateLabel();
			btn.style.cssText = [
				'background:#fff',
				'border:none',
				'border-radius:2em',
				'padding:8px 12px',
				'font-family:Arial,sans-serif',
				'font-size:14px',
				'font-weight:600',
				'color:#4a4a4a',
				'cursor:pointer',
				'width:100%',
				'text-align:center',
				'white-space:nowrap',
				'overflow:hidden',
				'box-shadow:0 1px 4px rgba(0,0,0,0.15)',
			].join(';');

			const panel = document.createElement('div');
			panel.style.cssText = [
				'display:none',
				'position:absolute',
				'top:42px',
				'left:0',
				'background:white',
				'border:1px solid #e0e0e0',
				'border-radius:0.75em',
				'padding:8px 4px',
				'z-index:1000',
				'min-width:190px',
				'box-shadow:0 2px 8px rgba(0,0,0,0.12)',
			].join(';');

			[...options].sort().forEach(opt => {
				const lbl = document.createElement('label');
				lbl.style.cssText = [
					'display:flex',
					'align-items:center',
					'gap:8px',
					'font-family:Arial,sans-serif',
					'font-size:14px',
					'font-weight:600',
					'cursor:pointer',
					'padding:5px 12px',
					'white-space:nowrap',
					'color:#4a4a4a',
					'border-radius:0.4em',
				].join(';');
				lbl.addEventListener('mouseenter', () => (lbl.style.backgroundColor = '#f0f4ff'));
				lbl.addEventListener('mouseleave', () => (lbl.style.backgroundColor = ''));
				const cb = document.createElement('input');
				cb.type = 'checkbox';
				cb.value = opt;
				cb.addEventListener('change', () => {
					onToggle(cb.value, cb.checked);
					updateLabel();
				});
				lbl.appendChild(cb);
				lbl.appendChild(document.createTextNode(opt));
				panel.appendChild(lbl);
			});

			btn.addEventListener('click', e => {
				e.stopPropagation();
				const open = panel.style.display === 'block';
				this._ddPanels.forEach(p => (p.style.display = 'none'));
				panel.style.display = open ? 'none' : 'block';
			});

			wrap.appendChild(btn);
			wrap.appendChild(panel);
			this._ddPanels.push(panel);
			ddBar.appendChild(wrap);
		};

		makeDropdown(
			'AREA',
			areas,
			() => this.selectedAreas.size,
			(val, checked) => {
				checked ? this.selectedAreas.add(val) : this.selectedAreas.delete(val);
				this.filterCategories();
			},
		);
		makeDropdown(
			'SKILLS',
			skills,
			() => this.selectedSkills.size,
			(val, checked) => {
				checked ? this.selectedSkills.add(val) : this.selectedSkills.delete(val);
				this.filterCategories();
			},
		);
		makeDropdown(
			'THEMES',
			themes,
			() => this.selectedThemes.size,
			(val, checked) => {
				checked ? this.selectedThemes.add(val) : this.selectedThemes.delete(val);
				this.filterCategories();
			},
		);

		this.rootDom.node.appendChild(ddBar);
		this.dropdownDoms = [{ node: ddBar }];

		this._closeDropdowns = () => this._ddPanels.forEach(p => (p.style.display = 'none'));
		document.addEventListener('click', this._closeDropdowns);
		this.events.once('shutdown', () => document.removeEventListener('click', this._closeDropdowns));

		if (this.introActive) {
			searchInput.disabled = true;
			ddBar.style.pointerEvents = 'none';
			this.rootDom.node.style.filter = 'brightness(0.4)';
		}
	}

	buildCategoryList() {
		const titleCount = {};
		this.categories.forEach(cat => {
			titleCount[cat.title] = (titleCount[cat.title] || 0) + 1;
		});
		const titleSeen = {};

		// List is appended into the shared root DOM (no separate add.dom needed)
		const listEl = document.createElement('div');
		listEl.style.cssText = [
			'width:415px',
			'height:685px',
			'margin-top:7px',
			'overflow-y:' + (this.introActive ? 'hidden' : 'auto'),
			'overflow-x:hidden',
			'scrollbar-width:thin',
			'scrollbar-color:#aaa transparent',
			...(this.introActive ? ['visibility:hidden'] : []),
		].join(';');
		this._listEl = listEl;
		this.rootDom.node.appendChild(listEl);

		this.categories.forEach(cat => {
			const id = parseInt(cat.id);

			let displayTitle = cat.title.toUpperCase();
			if (titleCount[cat.title] > 1) {
				titleSeen[cat.title] = (titleSeen[cat.title] || 0) + 1;
				displayTitle += ` [${titleSeen[cat.title]}]`;
			}
			displayTitle = displayTitle.replace('THEATRES: MENTAL HEALTH - ', 'THEATRES: ');

			const rowEl = document.createElement('div');
			rowEl.style.cssText = [
				'display:flex',
				'align-items:flex-start',
				'gap:6px',
				'padding:7px 10px',
				'cursor:pointer',
				'border-radius:4px',
				'user-select:none',
			].join(';');

			const tickEl = document.createElement('img');
			tickEl.src = 'assets/tick.png';
			tickEl.style.cssText = 'display:none;height:18px;width:auto;flex-shrink:0;margin-top:2px;';

			const labelEl = document.createElement('span');
			labelEl.textContent = displayTitle;
			// No white-space:nowrap — long titles wrap instead of being clipped
			labelEl.style.cssText = 'font:bold 17px Arial,sans-serif;color:#000;line-height:1.3;';

			rowEl.addEventListener('mouseenter', () => {
				if (rowEl.style.pointerEvents !== 'none') rowEl.style.backgroundColor = '#f0f4ff';
			});
			rowEl.addEventListener('mouseleave', () => {
				rowEl.style.backgroundColor = '';
			});

			const tickShim = {
				setVisible: v => {
					tickEl.style.display = v ? 'inline' : 'none';
				},
				setY: () => {},
			};

			const buttonShim = {
				_visible: true,
				setInteractive: () => {
					rowEl.style.pointerEvents = '';
					rowEl.style.cursor = 'pointer';
				},
				disableInteractive: () => {
					rowEl.style.pointerEvents = 'none';
					rowEl.style.cursor = 'default';
				},
				setVisible: v => {
					buttonShim._visible = v;
					rowEl.style.display = v ? 'flex' : 'none';
				},
				get visible() {
					return buttonShim._visible;
				},
				setY: () => {},
				setFill: c => {
					labelEl.style.color = c;
				},
			};

			rowEl.addEventListener('click', () => {
				if (this.categorySelected === id) return;
				clickSound.play();
				this.categorySelected = id;
				this.categorySelection(buttonShim);
				this.scenarioBox.setTexture('preview-scenario-' + id);
				this.feedbackBox.setTexture('preview-feedback-' + id);
			});

			if (this.introActive) buttonShim.disableInteractive();

			rowEl.appendChild(tickEl);
			rowEl.appendChild(labelEl);
			listEl.appendChild(rowEl);

			this.categoryRows.push({
				id,
				key: cat.title,
				area: cat.area ? cat.area.split(';').map(v => v.trim()) : [],
				skills: cat.skills ? cat.skills.split(';').map(v => v.trim()) : [],
				themes: cat.themes ? cat.themes.split(';').map(v => v.trim()) : [],
				button: buttonShim,
				tick: tickShim,
			});
		});
	}

	categorySelection(newBtn) {
		if (this.categorySelected !== null) {
			this.btnCategorySelection.setVisible(true);
			this.btnCategorySelection.setTexture(
				this.selection.includes(this.categorySelected) ? 'unselect-scenario' : 'select-scenario',
			);
		}

		newBtn.setFill('#e6335d');
		if (this.oldSelection) this.oldSelection.setFill('#000000');
		this.oldSelection = newBtn;

		this.btnCategorySelection.setTexture(
			this.selection.includes(this.categorySelected) ? 'unselect-scenario' : 'select-scenario',
		);
	}

	rowMatchesFilters(row) {
		const terms = String(this.searchTerm || '')
			.toLowerCase()
			.split(',')
			.map(t => t.trim())
			.filter(t => t.length > 0);

		if (terms.length > 0) {
			const allText = [row.key, ...row.area, ...row.skills, ...row.themes].join(' ').toLowerCase();
			if (!terms.some(t => allText.includes(t))) return false;
		}

		if (this.selectedAreas.size > 0 && !row.area.some(a => this.selectedAreas.has(a))) return false;
		if (this.selectedSkills.size > 0 && !row.skills.some(s => this.selectedSkills.has(s)))
			return false;
		if (this.selectedThemes.size > 0 && !row.themes.some(t => this.selectedThemes.has(t)))
			return false;

		return true;
	}

	filterCategories() {
		this.categoryRows.forEach(row => {
			const visible = this.rowMatchesFilters(row);
			row.button.setVisible(visible);
			row.tick.setVisible(visible && this.selection.includes(row.id));
		});
	}

	selectAll() {
		this.categoryRows
			.filter(row => this.rowMatchesFilters(row))
			.forEach(row => {
				if (!this.selection.includes(row.id)) this.selection.push(row.id);
				row.tick.setVisible(true);
			});

		if (this.categorySelected !== null) {
			this.btnCategorySelection.setTexture('unselect-scenario');
		}
	}

	categoryClear() {
		const visibleIds = this.categoryRows
			.filter(row => this.rowMatchesFilters(row))
			.map(row => row.id);

		this.selection = this.selection.filter(id => !visibleIds.includes(id));

		this.categoryRows.forEach(row => {
			if (row.button.visible) row.tick.setVisible(false);
		});

		if (this.categorySelected !== null) {
			this.btnCategorySelection.setTexture('select-scenario');
		}

		// Reset dropdown filters (uncheck all checkboxes, triggers label update via change event)
		if (this._ddPanels) {
			this._ddPanels.forEach(panel => {
				panel.querySelectorAll('input[type="checkbox"]').forEach(cb => {
					if (cb.checked) {
						cb.checked = false;
						cb.dispatchEvent(new Event('change'));
					}
				});
			});
		}

		// Reset search
		if (this.searchDom) {
			this.searchDom.node.value = '';
			this.searchTerm = '';
		}

		this.filterCategories();
	}

	categoryAddition(categoryId) {
		const row = this.categoryRows.find(r => r.id === categoryId);
		if (!row) return;

		if (this.selection.includes(categoryId)) {
			this.selection = this.selection.filter(id => id !== categoryId);
			this.btnCategorySelection.setTexture('select-scenario');
			row.tick.setVisible(false);
		} else {
			this.selection.push(categoryId);
			this.btnCategorySelection.setTexture('unselect-scenario');
			row.tick.setVisible(true);
		}
	}

	warning() {
		this.popup = this.add.image(
			this.cameras.main.width / 2,
			this.cameras.main.height / 2,
			'popup-select-scenario',
		);

		const toggle = enabled => {
			const method = enabled ? 'setInteractive' : 'disableInteractive';
			const args = enabled ? [{ useHandCursor: true }] : [];
			[this.btnNext, this.btnCategoryClear, this.btnSelectAll, this.btnCategorySelection].forEach(
				btn => btn[method](...args),
			);
			this.categoryRows.forEach(row => row.button[method](...args));
			if (this.searchDom) this.searchDom.node.disabled = !enabled;
			if (this.dropdownDoms)
				this.dropdownDoms.forEach(d => (d.node.style.pointerEvents = enabled ? '' : 'none'));
		};

		toggle(false);
		setTimeout(() => {
			this.popup.destroy();
			toggle(true);
		}, 2500);
	}
}

